import { render } from "./NewMermaidChart.vue?vue&type=template&id=5f2d3100&scoped=true"
import script from "./NewMermaidChart.vue?vue&type=script&lang=js"
export * from "./NewMermaidChart.vue?vue&type=script&lang=js"

import "./NewMermaidChart.vue?vue&type=style&index=0&id=5f2d3100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2d3100"]])

export default __exports__